/**
 * List of generic handouts that can be selected when creating a SurveyNote - these live in the public/yph_pdfs dir
 * (Practices can also add their own custom handouts).
 */
export default {
    defaultHandouts: [
        { label: 'DASH Diet', pdf: 'DASH Diet.pdf' },
        { label: 'Exercising with amyotrophic lateral sclerosis', pdf: 'YPH_ALS.pdf' },
        { label: 'Exercising and Alzheimer\'s', pdf: 'YPH_Alzheimers.pdf' },
        { label: 'Exercising with anemia', pdf: 'YPH_Anemia.pdf' },
        { label: 'Exercising with an aneurysm', pdf: 'YPH_Aneurysm.pdf' },
        { label: 'Exercising with angina', pdf: 'YPH_Angina.pdf' },
        { label: 'Exercising with anxiety and depression', pdf: 'YPH_AnxietyDepression.pdf' },
        { label: 'Exercising with asthma', pdf: 'YPH_Asthma.pdf' },
        { label: 'Exercising with cancer', pdf: 'YPH_Cancer.pdf' },
        { label: 'Exercising following cardiac transplant', pdf: 'YPH_CardiacTransplant.pdf' },
        { label: 'Exercising with cerebral palsy', pdf: 'YPH_CerebralPalsy.pdf' },
        { label: 'Exercising with chronic heart failure', pdf: 'YPH_ChronicHeartFailure.pdf' },
        { label: 'Exercising with chronic obstructive pulmonary disease', pdf: 'YPH_COPD.pdf' },
        { label: 'Exercising with chronic restrictive pulmonary disease', pdf: 'YPH_CRPD.pdf' },
        { label: 'Exercising with epilepsy', pdf: 'YPH_Epilepsy.pdf' },
        { label: 'Exercising with frailty', pdf: 'YPH_Frailty.pdf' },
        { label: 'Exercising with hearing loss', pdf: 'YPH_HearingLoss.pdf' },
        { label: 'Exercising with hyperlipidemia', pdf: 'YPH_Hyperlipidemia.pdf' },
        { label: 'Exercising with hypertension', pdf: 'YPH_Hypertension.pdf' },
        { label: 'Exercising following lung or heart-lung transplantation', pdf: 'YPH_LungTransplant.pdf' },
        { label: 'Exercising with mental retardation', pdf: 'YPH_MentalRetardation.pdf' },
        { label: 'Exercising with muscular dystrophy', pdf: 'YPH_MuscularDystrophy.pdf' },
        { label: 'Exercising with osteoporosis', pdf: 'YPH_Osteoporosis.pdf' },
        {
            label: 'Exercising with a pacemaker or implantable cardioverter defibrillator',
            pdf: 'YPH_Pacemaker.pdf'
        },
        { label: 'Exercising with peripheral arterial disease', pdf: 'YPH_PAD.pdf' },
        { label: 'Exercising with Parkinson\'s disease', pdf: 'YPH_Parkinsons.pdf' },
        { label: 'Exercising following a stroke', pdf: 'YPH_Stroke.pdf' },
        { label: 'Exercising with type 2 diabetes', pdf: 'YPH_Type2Diabetes.pdf' },
        { label: 'Exercising with valvular heart disease', pdf: 'YPH_ValvularHeartDisease.pdf' },
        { label: 'Exercising with visual impairment', pdf: 'YPH_VisualImpairment.pdf' },
        { label: 'Exercising with end - stage metabolic disease', pdf: 'YPH_EndStageMetabolicDisease.pdf' },
        { label: 'Exercising while losing weight', pdf: 'YPH_LosingWeight.pdf' },
        { label: 'Exercising following coronary artery bypass graft surgery', pdf: 'YPH_CoronaryBypassSurgery.pdf' },
        { label: 'Exercising following a heart attack', pdf: 'YPH_HeartAttack.pdf' },
        { label: 'Exercising with multiple sclerosis', pdf: 'YPH_MultipleSclerosis.pdf' },
        { label: 'Exercising with polio or post - polio syndrome', pdf: 'YPH_Polio.pdf' },
    ]
}
